import { Typography } from "@/components/atoms";
import { BookingHistoryTable } from "@/components/organisms/BookingHistory";
import { YourDetailsSection } from "@/components/organisms/YourDetails";
import { useClientScope } from "@/components/pages/Client/settings/ClientScopeContext";
import { useGetClientProfileQuery } from "@/redux/apis/clientProfile/clientProfileApi";

/**
 * Client-portal Manage-Client Details tab (DEV-410): the managed client's profile read-card
 * (reused `YourDetailsSection`) + booking history (reused `BookingHistoryTable`). Account scoping
 * comes from the takeover shell's `ClientScopeProvider`, so this tab reads the target via
 * `useClientScope()` and does not re-wrap it. Per the DEV-408 scope decisions there is no
 * period-stats strip and no "Book a Trip" button.
 */
export const ManageClientDetails = () => {
  const { accountId, isViewOnly } = useClientScope();
  // Deduped with YourDetailsSection's own query (same RTK key); supplies the heading name.
  const { data: profile } = useGetClientProfileQuery({ accountId });
  const clientName = [profile?.personal.first_name, profile?.personal.last_name].filter(Boolean).join(" ");

  return (
    <div className="flex flex-1 flex-col">
      <div className="flex flex-col gap-6 px-3 pb-12 pt-4 lg:px-5">
        <Typography variant="h2">{clientName ? `${clientName}'s Details` : "Client Details"}</Typography>

        <YourDetailsSection readOnly={!!isViewOnly} />
        {/* No clientId prop → client-scoped /v2/cust/booking path; the shell's ClientScopeProvider
            supplies the managed account_uuid (EA OBO). clientId is the operator-dashboard path only. */}
        <BookingHistoryTable />
      </div>
    </div>
  );
};
